import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Close from '@hellodarwin/icons/dist/icons/Close';
import { StyledTag, TagDot } from './styles';
import TooltipWrapper from './tooltip-wrapper';
const HdTag = ({ text, icon, color, size, shape = 'square', style, onClick, onClose, hoverable, iconPosition, onMouseEnter, onMouseLeave, onPointerEnter, onPointerLeave, highContrastText, withBorder, tooltip, pageLink, dotted, }) => {
    const handleClick = (e) => {
        e.stopPropagation();
        if (!!onClose && !onClick) {
            return onClose();
        }
        if (pageLink) {
            return window.open(pageLink, '_blank', 'noopener,noreferrer');
        }
        return onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return (_jsx(TooltipWrapper, { tooltip: tooltip, children: _jsxs(StyledTag, { className: "notranslate", translate: "no", onClick: handleClick, "$size": size, "$color": color, "$shape": shape, style: style, "$hoverable": hoverable, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave, "$withBorder": withBorder, "$highContrastText": highContrastText, children: [dotted && _jsx(TagDot, {}), iconPosition !== 'end' && icon, _jsx("span", { translate: "no", children: text }), iconPosition === 'end' && icon, !!onClose && (_jsx(Close, { style: { flexShrink: 0 }, onClick: (e) => {
                        e.stopPropagation();
                        onClose();
                    }, size: 12 }))] }) }));
};
export default HdTag;
